<template>
  <div class="special-main" v-if="info">
    <div class="header">
      <div class="flex flex-center flex-between wrap">
        <h1>您好，欢迎来到{{ info.title }}！</h1>
        <div class="date flex flex-center">
          <div style="margin-right: 10px">
            <router-link to="/">&lt;&nbsp;返回主页面</router-link>
          </div>
          <div class="flex flex-center">
            <img src="~@/assets/images/special/date.png" alt="" />
            <span>{{ formatDate() }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="top flex flex-center flex-between wrap">
      <div class="logo flex flex-center">
        <img :src="info.logo" alt="" />
        <h1>{{ info.title }}</h1>
      </div>

      <div class="search">
        <input v-model="keywords" type="text" placeholder="请输入关键字" />
        <button @click="search">
          <svg
            t="1758765894641"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4715"
            width="19"
            height="19"
          >
            <path
              d="M446.112323 177.545051c137.567677 0.219798 252.612525 104.59798 266.162424 241.493333 13.562828 136.895354-78.778182 261.818182-213.617777 289.008485-134.852525 27.203232-268.386263-52.156768-308.945455-183.608889s25.018182-272.252121 151.738182-325.779394A267.235556 267.235556 0 0 1 446.112323 177.545051m0-62.060607c-182.794343 0-330.989899 148.195556-330.989899 330.989899s148.195556 330.989899 330.989899 330.989899 330.989899-148.195556 330.989899-330.989899-148.195556-330.989899-330.989899-330.989899z m431.321212 793.341415a30.849293 30.849293 0 0 1-21.94101-9.102223l-157.220202-157.220202c-11.752727-12.179394-11.584646-31.534545 0.37495-43.50707 11.972525-11.972525 31.327677-12.140606 43.494141-0.37495l157.220202 157.220202a31.036768 31.036768 0 0 1 6.723232 33.810101 31.004444 31.004444 0 0 1-28.651313 19.174142z m0 0"
              p-id="4716"
              fill="#ffffff"
            ></path>
          </svg>
        </button>
      </div>
    </div>
    <div class="special-nav wrap">
      <router-link
        v-for="(item, index) in navList"
        :key="index"
        :to="item.name == '首页' ? item.url : item.url + '&id=' + item.id"
        :style="{ background: info.color }"
        >{{ item.name }}</router-link
      >
    </div>

    <div class="special-container wrap">
      <div class="banner">
        <img :src="info.banner" style="width: 100%" alt="" />
      </div>
      <router-view></router-view>
    </div>

    <foot :background="info.color"></foot>
  </div>
</template>

<script>
import foot from "./foot.vue";
export default {
  components: {
    foot,
  },
  data() {
    return {
      info: null,
      navList: [],
      keywords: "",
    };
  },
  methods: {
    search() {
      if (this.keywords.trim() == "") {
        this.$message({
          message: "搜索栏关键字不能为空",
          type: "warning",
        });
        return;
      }
      this.$router
        .replace({
          path: "/special/search",
          query: {
            sybh: this.$route.query.sybh,
            keywords: this.keywords,
          },
        })
        .catch((err) => {});
    },
    getBaiscInfo() {
      this.$request("/web/getOther", "get", {
        sybh: this.$route.query.sybh,
      }).then((res) => {
        this.info = res.data.data;
      });
    },

    getNav() {
      this.$request("/web/getNav", "get", {
        sybh: this.$route.query.sybh,
      }).then((res) => {
        this.navList = res.data.data;
      });
    },

    formatDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekday = weekdays[date.getDay()];

      return `${year}年${month}月${day}日 ${weekday}`;
    },
  },
  mounted() {
    this.getBaiscInfo();
    this.getNav();
  },
};
</script>

<style lang="less" scoped>
.special-main {
  background: url(~@/assets/images/special/bg.png) no-repeat center top;
  background-size: 100%;
  .header {
    height: 35px;
    font-size: 14px;
    color: #fff;
    border-bottom: 1px solid #b1d9eb;
    .wrap {
      height: 100%;
    }
    span {
      margin-left: 10px;
    }
  }

  .top {
    padding: 40px 0 50px;
    .logo {
      h1 {
        margin-left: 20px;
        color: #fff;
        font-size: 34px;
        font-weight: bold;
      }
    }
    .search {
      width: 280px;
      height: 35px;
      border: 1px solid #fff;
      border-radius: 35px;
      background: #8bc7e1;
      display: flex;
      padding-left: 15px;
      input {
        height: 100%;
        flex: 1;
        color: #f9f9f9;
        font-size: 15px;
        &::-webkit-input-placeholder {
          color: #f9f9f9;
        }
      }
      button {
        width: 35px;
        height: 35px;
        cursor: pointer;
      }
    }
  }

  .special-nav {
    display: flex;
    a {
      display: block;
      padding: 20px 0 16px;
      flex: 1;
      text-align: center;
      background: #2ca1c9;
      color: #fff;
    }
  }
}

.special-container {
  background: #fff;
  padding: 14px 18px;
}
</style>